import { INITIAL_USER } from '../../utils/constants';

export function clearUserData(state) {
  state.user = { ...INITIAL_USER };
}

export function setUser(state, user) {
  state.user = { ...user };
}

export function setState(state, [field, value]) {
  state[field] = value;
}

export function setUserOrganisations(state, organisations) {
  state.userOrganisations = [...organisations];
}

export function setORGBranding(state, branding = {}) {
  state.ORGBranding = branding;
}
